import type { ReactNode } from 'react';
import { chip } from './Chip.css';

interface ChipProps {
  selected?: boolean;
  exclusion?: boolean;
  onClick: () => void;
  children: ReactNode;
}

export function Chip({ selected, exclusion, onClick, children }: ChipProps) {
  return (
    <button type="button" className={chip} aria-pressed={selected}
            data-exclusion={exclusion ? 'true' : undefined} onClick={onClick}>
      {children}
    </button>
  );
}
